import { Component, Input } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { PermissionService } from '@services/permission.service';
import { Permissao } from '@models/enums/permissao';
//import { Auth } from '../../auth/models/auth';

@Component({
  selector: 'smrts-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false
})

export class MenuComponent {

  @Input() menuDrawer: MatDrawer;

  protected get permissaoEditarLancamento() { return Permissao.EDITAR_LANCAMENTO_CAIXA; }
  protected get permissaoVisualizarRelatorioCaixa() { return Permissao.VISUALIZAR_RELATORIO_CAIXA; }
  protected get permissaoVisualizarConfiguracaoCaixa() { return Permissao.VISUALIZAR_CONFIGURACAO_CAIXA; }
  protected get permissaoVisualizarMovimentacaoCaixa() { return Permissao.VISUALIZAR_MOVIMENTACAO_CAIXA; }
  protected get permissaoVisualizarPainelFinanceiro() { return Permissao.VISUALIZAR_PAINEL_FINANCEIRO; }
  protected get permissaoAdministrarContas() { return Permissao.ADMINISTRAR_CONTAS; }
  protected get permissaoVisualizarRegraConciliacaoAutomatica() { return Permissao.VISUALIZAR_REGRA_CONCILIACAO_AUTOMATICA; }
  protected get permissaoEditarRoteiroVistoria() { return Permissao.EDITAR_ROTEIRO_VISTORIA; }
  protected get permissaoRealizarVistoria() { return Permissao.REALIZAR_VISTORIA; }
  protected get permissoesVistoria() { return [Permissao.REALIZAR_VISTORIA, Permissao.EDITAR_ROTEIRO_VISTORIA]; }

  constructor(private permissionService: PermissionService) {}

  //auth = new Auth();
}
